<template>
  <div class="ref-fed-name">
    <span>{{ storeFederationName || 'RDRS' }}</span>
  </div>
</template>

<script>
export default {
  computed: {
    storeFederationName() {
      return this.$store.state.federationName;
    }
  }
}
</script>

<style scoped>
.ref-fed-name {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.3px;
  white-space: nowrap;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}
</style>